import { css } from '@grupoboticario/flora-react'

export const zoomableInnerClasses = css({
  variants: {
    variant: {
      dragging: {
        cursor: 'grabbing',
      },
      zoomIn: {
        cursor: 'zoom-in',
      },
      zoomOut: {
        cursor: 'zoom-out',
      },
    },
  },
})
